<template>
    <div>
       	<label class="lable-full-width">PAN (Self-Attested)*</label>
        <input type="file" ref="pan"  @change="getFile" hidden data-from='pan'/>
        <label class="choose-btn" @click="$refs.pan.click()">Choose file</label>
        <span id="file-chosen">{{f_data.pan_url}}</span>
    </div>
</template>
<script>
import file from '../services/fileupload'
import ls from '../services/ls'
export default {
    name:'pan_upload',
    props:['propdata','from_key'],
    watch:{
        propdata:function (data){
            this.f_data = data
        }
    },
    data() {
        return{
            f_data:{},
        }
    },
    methods: {
        getFile(){
            let formData = new FormData();
            for (var i = 0; i < this.$refs.pan.files.length; i++) {
                let file = this.$refs.pan.files[i];
                formData.append('files[' + i + ']', file);
            }
            formData.append('subscription_id', this.propdata.subscribtion_id)
            formData.append('slug', this.propdata.type)
            formData.append('folder_id', this.propdata.folder_id)
            formData.append('session_user', ls.get('_u_unique'));
            formData.append('label', 'PAN');
            file.uploadProofs(formData)
            .then(response =>{
                 this.$emit("UpdateFilePath", {
                    	src: 'pan_url',
                    	url: response.data.file_url,
                    	action:this.from_key
                });
            })
        }
    }
}
</script>